import {
  useState,
  useEffect,
  useRef,
  memo,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from 'UI/components/Button';
import styles from './styles.module.scss';
import SearchInput from '../SearchInput';

const SearchInputModal = ({ isFullscreenSearch, closeFullscreenSearch }) => {
  const inputRef = useRef(null);

  const [inputValue, setInputValue] = useState('');

  const handleOnCloseModalWindow = useCallback(() => {
    closeFullscreenSearch();
    setInputValue('');
  }, [closeFullscreenSearch]);

  useEffect(() => {
    if (isFullscreenSearch && inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isFullscreenSearch]);

  const modalRef = useRef(null);

  const handleOnClick = ({ target }) => {
    if (modalRef && modalRef.current) {
      if (modalRef.current.isEqualNode(target)) handleOnCloseModalWindow();
    }
  };

  return (
    <section
      className={cn(styles.modalWindowContainer, { [styles.show]: isFullscreenSearch })}
      onClick={handleOnClick}
      ref={modalRef}
      role="dialog"
    >
      <div className={styles.modalWindow}>
        <SearchInput
          inputRef={inputRef}
          inputValue={inputValue}
          setInputValue={setInputValue}
          onClose={handleOnCloseModalWindow}
        />
        <Button
          onClick={handleOnCloseModalWindow}
          className={styles.cancelButton}
        >
          Cancel
        </Button>
      </div>
    </section>
  );
};

SearchInputModal.defaultProps = {
  isFullscreenSearch: false,
};

SearchInputModal.propTypes = {
  isFullscreenSearch: PropTypes.bool,
  closeFullscreenSearch: PropTypes.func.isRequired,
};

export default memo(SearchInputModal);
